export default __webpack_public_path__ + "static/media/proclamation11.9dbfa184.jpg";